export class EksportujDaneModel {
  idProjektu: string;
  idLokalizacji: string;
  czyOswiadczenia: boolean;
}
